var _path, _g, _ellipse, _ellipse2, _ellipse3, _ellipse4, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgContactRoundShape(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 607,
    height: 613,
    viewBox: "0 0 607 613",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M124.095 506.09C121.75 509.052 117.436 509.549 114.545 507.117C62.3701 463.229 28.0772 401.458 18.3974 333.605C8.3937 263.482 25.4345 192.168 66.0312 134.261C106.628 76.3543 167.71 36.2357 236.772 22.1181C303.617 8.45379 373.045 20.1481 431.723 54.7969C434.956 56.7061 435.932 60.9025 433.959 64.0969C431.972 67.3122 427.754 68.2911 424.497 66.3744C368.778 33.5868 302.907 22.5399 239.481 35.5053C173.816 48.9283 115.74 87.0729 77.1408 142.13C38.5416 197.188 22.3393 264.993 31.8508 331.666C41.0416 396.091 73.5697 454.749 123.062 496.467C125.93 498.885 126.423 503.148 124.095 506.09Z",
    fill: "white"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_373_1380)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M453.927 66.8016C458.926 59.695 468.777 57.9694 475.589 63.3634C531.459 107.608 569.568 170.859 582.483 241.455C596.347 317.238 580.076 395.456 537.156 459.346C494.237 523.237 428.084 567.717 352.873 583.255C282.781 597.736 210.02 586.006 148.167 550.604C140.659 546.307 138.574 536.579 143.243 529.296C147.932 521.981 157.652 519.911 165.222 524.177C220.143 555.121 284.521 565.288 346.557 552.472C413.745 538.591 472.842 498.856 511.184 441.78C549.525 384.704 564.061 314.829 551.676 247.129C540.234 184.585 506.656 128.494 457.418 89.0178C450.67 83.6075 448.951 73.876 453.927 66.8016Z",
    fill: "#BAE900"
  }))), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 422.587,
    cy: 57.4599,
    rx: 16.0592,
    ry: 16.0888,
    fill: "white"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 422.587,
    cy: 57.4603,
    rx: 10.5532,
    ry: 10.5726,
    fill: "white"
  })), _ellipse3 || (_ellipse3 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 120.673,
    cy: 503.349,
    rx: 16.0592,
    ry: 16.0888,
    fill: "white"
  })), _ellipse4 || (_ellipse4 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 120.673,
    cy: 503.348,
    rx: 10.5532,
    ry: 10.5726,
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_373_1380",
    x: 121.764,
    y: 45.5968,
    width: 484.546,
    height: 567.113,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    radius: 1,
    operator: "erode",
    in: "SourceAlpha",
    result: "effect1_dropShadow_373_1380"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4.4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 10
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.0745098 0 0 0 0 0.0627451 0 0 0 0 0.133333 0 0 0 0.05 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_373_1380"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_373_1380",
    result: "shape"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgContactRoundShape);
export default __webpack_public_path__ + "static/media/contact-round-shape.6a8d25e68287c31f04ef52a52b58d6a5.svg";
export { ForwardRef as ReactComponent };